import {UI} from "../../stem-core/src/ui/UIBase.js";
import {UserChargesList} from "../components/users/payments/UserChargesList.jsx";

export class AdminChargesPage extends UI.Element {
    render() {
        return <UserChargesList />;
    }
}
